var map = {
	"./About.vue": [
		"252b"
	],
	"./AboutCN.vue": [
		"44f7"
	],
	"./AccountAssets/components/AssetsLiveAccount.vue": [
		"421b"
	],
	"./AccountAssets/index.vue": [
		"5879"
	],
	"./AccountInformation/children/AddressCompleted.vue": [
		"6baa",
		"chunk-a0bacb5e"
	],
	"./AccountInformation/children/AddressFailed.vue": [
		"44e0",
		"chunk-b4211604"
	],
	"./AccountInformation/children/Certification.vue": [
		"dfd3",
		"chunk-5825ad0d"
	],
	"./AccountInformation/children/FundTransfer.vue": [
		"487d",
		"chunk-1e73945f"
	],
	"./AccountInformation/children/FundsDetails.vue": [
		"4a4c",
		"chunk-5c68c465"
	],
	"./AccountInformation/children/HistoricalOrders.vue": [
		"faf9",
		"chunk-c61f5774",
		"chunk-09a59ee4"
	],
	"./AccountInformation/children/MyAccount.vue": [
		"92d4",
		"chunk-5004b7b6"
	],
	"./AccountInformation/children/SelfieHolding.vue": [
		"9d54",
		"chunk-3be0e3a8"
	],
	"./AccountInformation/children/SubmitSign.vue": [
		"16dc",
		"chunk-7e28cb1c"
	],
	"./AccountInformation/components/Certification/ConfirmAgreement.vue": [
		"8942",
		"chunk-66aee788"
	],
	"./AccountInformation/components/Certification/SubmitDocuments.vue": [
		"5384",
		"chunk-fb16ef34"
	],
	"./AccountInformation/components/Certification/SubmitInformation.vue": [
		"1044",
		"chunk-4a2a81f0"
	],
	"./AccountInformation/components/Certification/UnderReview.vue": [
		"a185",
		"chunk-5f07308c"
	],
	"./AccountInformation/components/HistoricalOrders/BillCancelled.vue": [
		"bb1f",
		"chunk-78df284d"
	],
	"./AccountInformation/components/HistoricalOrders/ClosedPosition.vue": [
		"ce88",
		"chunk-29af7756"
	],
	"./AccountInformation/components/HistoricalOrders/LiveAccount.vue": [
		"a2c5",
		"chunk-c61f5774"
	],
	"./AccountInformation/components/MyAccount/AddWithdrawalAddress.vue": [
		"2a22",
		"chunk-5c694d74"
	],
	"./AccountInformation/components/MyAccount/BindEmail.vue": [
		"20e1",
		"chunk-a0660508"
	],
	"./AccountInformation/components/MyAccount/ChangeLoginPassword.vue": [
		"b321",
		"chunk-2ea0803d"
	],
	"./AccountInformation/components/MyAccount/ModifyHeadImg.vue": [
		"5727",
		"chunk-0f780ace"
	],
	"./AccountInformation/components/MyAccount/ModifyNickName.vue": [
		"9cbd",
		"chunk-29dab7cd"
	],
	"./AccountInformation/components/MyAccount/PersonalData.vue": [
		"1430",
		"chunk-463b1090"
	],
	"./AccountInformation/components/MyAccount/ResetMT4LivePassword.vue": [
		"9f5d",
		"chunk-0860a3b3"
	],
	"./AccountInformation/components/MyAccount/ResetMT5LivePassword.vue": [
		"cdbe",
		"chunk-77c44b06"
	],
	"./AccountInformation/components/MyAccount/SetLoginPassword.vue": [
		"5425",
		"chunk-e6f11378"
	],
	"./AccountInformation/index.vue": [
		"4d2f"
	],
	"./ArticleDetails.vue": [
		"e5b7",
		"chunk-2d225d7b"
	],
	"./Congratulation.vue": [
		"11bd"
	],
	"./ContactUs.vue": [
		"fe35"
	],
	"./ContactUsCN.vue": [
		"f605"
	],
	"./Deposit/components/BankWireTransfer.vue": [
		"59ad"
	],
	"./Deposit/components/BlockChain.vue": [
		"dae0"
	],
	"./Deposit/components/CreditCard.vue": [
		"9401"
	],
	"./Deposit/components/OnlineBankTransfer.vue": [
		"e454"
	],
	"./Deposit/components/ScanningCode.vue": [
		"6a7c"
	],
	"./Deposit/components/USDTDeposit.vue": [
		"df6a"
	],
	"./Deposit/deposit.vue": [
		"1cc6"
	],
	"./Deposit/index.vue": [
		"4051"
	],
	"./Download.vue": [
		"5037"
	],
	"./FollowOrder.vue": [
		"0379"
	],
	"./FundHistory/components/FundHistoryBonus.vue": [
		"ed98"
	],
	"./FundHistory/components/FundHistoryDeposit.vue": [
		"37e3"
	],
	"./FundHistory/components/FundHistoryRebate.vue": [
		"7809"
	],
	"./FundHistory/components/FundHistoryTransfer.vue": [
		"80d6"
	],
	"./FundHistory/components/FundHistoryWithdrawal.vue": [
		"c423"
	],
	"./FundHistory/index.vue": [
		"c3f5"
	],
	"./FundsDetails/components/FundsDetailsLiveAccount.vue": [
		"cc96"
	],
	"./FundsDetails/index.vue": [
		"0cc5"
	],
	"./Home.vue": [
		"3cd8"
	],
	"./HomeCN.vue": [
		"72b8"
	],
	"./IBProgram.vue": [
		"6ac9"
	],
	"./LatestNews/children/Analysis.vue": [
		"d741",
		"chunk-b21ec280"
	],
	"./LatestNews/children/ArticleDetails.vue": [
		"8c47",
		"chunk-9e229074"
	],
	"./LatestNews/children/Calender.vue": [
		"3603",
		"chunk-3a48ecf2"
	],
	"./LatestNews/children/FastNews.vue": [
		"3010",
		"chunk-11db8a80"
	],
	"./LatestNews/children/LatestNews.vue": [
		"c6a6",
		"chunk-a2273f02"
	],
	"./LatestNews/children/Recommendations.vue": [
		"15e7",
		"chunk-193b838e"
	],
	"./LatestNews/index.vue": [
		"c274"
	],
	"./Login.vue": [
		"1003"
	],
	"./Privacy.vue": [
		"f376"
	],
	"./Promotion/Subpage/DepositBonus.vue": [
		"691d"
	],
	"./Promotion/Subpage/LuckSpin.vue": [
		"e3bc"
	],
	"./Promotion/Subpage/Membership.vue": [
		"8aed"
	],
	"./Promotion/Subpage/ReferralBonus.vue": [
		"6aa6"
	],
	"./Promotion/Subpage/SwitchingBonus.vue": [
		"6e7d"
	],
	"./Promotion/components/Advertise.vue": [
		"c031"
	],
	"./Promotion/index.vue": [
		"3f06"
	],
	"./SignUp/components/EmailLogin.vue": [
		"2655"
	],
	"./SignUp/components/ForgetEmailPwd.vue": [
		"9f33"
	],
	"./SignUp/components/ForgetPwd.vue": [
		"0e4f"
	],
	"./SignUp/components/PhoneLogin.vue": [
		"6e1d"
	],
	"./SignUp/index.vue": [
		"ced5"
	],
	"./Transaction/Transaction.vue": [
		"33cf",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-adb54448",
		"chunk-408ef3be",
		"chunk-50ee9f81"
	],
	"./Transaction/TransactionMn.vue": [
		"0237",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-adb54448",
		"chunk-9f1c1e74",
		"chunk-5610544f"
	],
	"./Transaction/composition/KLine.vue": [
		"3796",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-408ef3be",
		"chunk-bceeee6e",
		"chunk-bf0a0dfc"
	],
	"./Transaction/composition/KLine2.vue": [
		"0cf0",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-adb54448",
		"chunk-408ef3be",
		"chunk-5e5901c9"
	],
	"./Transaction/composition/KLineMn.vue": [
		"18ac",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-9f1c1e74",
		"chunk-bceeee6e",
		"chunk-2bb96da7"
	],
	"./Transaction/composition/KLineMn2.vue": [
		"5362",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-adb54448",
		"chunk-9f1c1e74",
		"chunk-1d845885"
	],
	"./Transaction/composition/TranSymbol.vue": [
		"e0e8",
		"chunk-39c44dc9"
	],
	"./Transaction/composition/assets.vue": [
		"d457",
		"chunk-5179bbf8"
	],
	"./Transaction/composition/assetsDemo.vue": [
		"5166",
		"chunk-42aab9ad"
	],
	"./Transaction/composition/business.vue": [
		"acb1",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-408ef3be"
	],
	"./Transaction/composition/businessDemo.vue": [
		"e9a7",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-9f1c1e74"
	],
	"./Transaction/composition/offerAnalysisRule.vue": [
		"8deb",
		"chunk-2703afa8"
	],
	"./Transaction/composition/orderList.vue": [
		"7dc8",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-b7b95afa"
	],
	"./Transaction/composition/orderList/ClosedPosition.vue": [
		"e48b",
		"chunk-566affba"
	],
	"./Transaction/composition/orderList/ModifyOrder.vue": [
		"2778",
		"chunk-302e79a6",
		"chunk-21965e96"
	],
	"./Transaction/composition/orderList/billCancelled.vue": [
		"660d",
		"chunk-103213fe"
	],
	"./Transaction/composition/orderList/onTheList.vue": [
		"5565",
		"chunk-302e79a6",
		"chunk-067f6a86"
	],
	"./Transaction/composition/orderList/positionData.vue": [
		"9e39",
		"chunk-5749305f",
		"chunk-726d0868"
	],
	"./Transaction/composition/orderList/stopProfitAndStopLoss.vue": [
		"9596",
		"chunk-81a9a252"
	],
	"./Transaction/composition/orderListDemo.vue": [
		"8d1f",
		"chunk-302e79a6",
		"chunk-5749305f",
		"chunk-232c105c"
	],
	"./Transaction/composition/orderListDemo/BillCancelled.vue": [
		"ec66",
		"chunk-08b9aafe"
	],
	"./Transaction/composition/orderListDemo/ClosedPosition.vue": [
		"ca51",
		"chunk-7742dad2"
	],
	"./Transaction/composition/orderListDemo/ModifyOrder.vue": [
		"b4ca",
		"chunk-302e79a6",
		"chunk-1c700588"
	],
	"./Transaction/composition/orderListDemo/onTheList.vue": [
		"9f64",
		"chunk-302e79a6",
		"chunk-40240ea5"
	],
	"./Transaction/composition/orderListDemo/positionData.vue": [
		"bfb1",
		"chunk-5749305f",
		"chunk-47174842"
	],
	"./Transaction/composition/orderListDemo/stopProfitAndStopLoss.vue": [
		"4d35",
		"chunk-5c0f0404"
	],
	"./WhyChooseUs.vue": [
		"e25c"
	],
	"./Withdrawal/components/BankTransfer.vue": [
		"f79c"
	],
	"./Withdrawal/components/BlockChainWithdraw.vue": [
		"8e56"
	],
	"./Withdrawal/components/NormalWithdraw.vue": [
		"d32c"
	],
	"./Withdrawal/components/USDTWithdraw.vue": [
		"a143"
	],
	"./Withdrawal/dialog/AddBankCard.vue": [
		"ad52"
	],
	"./Withdrawal/dialog/AddWithdrawalAddress.vue": [
		"1995"
	],
	"./Withdrawal/dialog/SafetyVerification.vue": [
		"babe"
	],
	"./Withdrawal/dialog/SelectWithdrawalAddress.vue": [
		"28b4"
	],
	"./Withdrawal/index.vue": [
		"9a17"
	],
	"./Withdrawal/withdrawal.vue": [
		"74a3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b0f4";
module.exports = webpackAsyncContext;